export default "__VITE_ASSET__6095ba9d__"